module.exports = "<pioneer-payment-title-summary\n  [iconClass]=\"'fa-exclamation-triangle'\"\n  [title]=\"errorTitle\"\n  [isCompleted]=\"false\"\n  [summary]=\"errorSummary\">\n</pioneer-payment-title-summary>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/payment/payment-error/payment-error.component.html
// module id = 8w4W
// module chunks = 0